var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8192 11.3092C12.2087 11.3092 11.6626 11.5502 11.2449 11.9277L5.51798 8.59438C5.55814 8.40964 5.59027 8.2249 5.59027 8.03213C5.59027 7.83936 5.55814 7.65462 5.51798 7.46988L11.1806 4.16867C11.6144 4.57028 12.1847 4.81928 12.8192 4.81928C14.1525 4.81928 15.2288 3.74297 15.2288 2.40964C15.2288 1.07631 14.1525 0 12.8192 0C11.4859 0 10.4096 1.07631 10.4096 2.40964C10.4096 2.60241 10.4417 2.78715 10.4818 2.97189L4.81919 6.27309C4.38545 5.87149 3.81517 5.62249 3.18063 5.62249C1.8473 5.62249 0.770996 6.6988 0.770996 8.03213C0.770996 9.36546 1.8473 10.4418 3.18063 10.4418C3.81517 10.4418 4.38545 10.1928 4.81919 9.79116L10.5381 13.1325C10.4979 13.3012 10.4738 13.4779 10.4738 13.6546C10.4738 14.9478 11.526 16 12.8192 16C14.1124 16 15.1646 14.9478 15.1646 13.6546C15.1646 12.3614 14.1124 11.3092 12.8192 11.3092Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.9e457460a1fcd840f6cace072764bd99.svg";
export { ForwardRef as ReactComponent };